export default __webpack_public_path__ + "static/media/dotblueLarge.f66871c4.jpg";